export default __webpack_public_path__ + "static/programs-hero-4c5e372470a7b80401de8927325de6c3.jpg";